<!--
  Mobile Cards Component Template
  ==============================
  
  Mobile-optimized template for displaying form entries in a card-based layout.
  This template provides a touch-friendly interface that eliminates complex table
  interactions and focuses on readability and accessibility for mobile devices.
  
  Key Features:
  - Card-based layout optimized for mobile screens
  - Touch-friendly interaction with clickable cards
  - Simplified data presentation without inline controls
  - Consistent field labeling and value display
  - Status field rendering with color-coded badges
  - Empty state handling for no data scenarios
  
  Design Philosophy:
  - Eliminates complex table interactions for mobile
  - Focuses on readability and touch accessibility
  - Provides consistent card layout across all form types
  - Integrates with advanced filtering modal for complex operations
  
  Mobile Optimizations:
  - Larger touch targets for better usability
  - Simplified data presentation without sorting controls
  - Card-based navigation for form entry viewing
  - Consistent spacing and typography for mobile screens
  
  @author MacSafety Development Team
  @version 1.0
-->

<div class="mobile-cards-wrapper" #mobileCardsWrapper>



  <!-- Empty State - Shown when no data is available -->
  <ion-item lines="none" *ngIf="!data?.length && !loadingState.isLoading" class="empty-state">
    <ion-text color="medium" class="ion-text-center">No entries found</ion-text>
  </ion-item>

  <!-- Mobile Cards Container - Main content area -->
  <div class="mobile-cards-container">
    <!-- Individual Entry Card - Clickable for navigation -->
    <ion-card 
      *ngFor="let row of data" 
      class="entry-card"
      button="true"
      (click)="onAction(row)">
      <ion-card-content>
        <div class="card-content">
          <!-- Dynamic Field Rendering - Based on column configuration -->
          <div *ngFor="let column of columns" class="card-field">
            <!-- Field Label - Column header text -->
            <div class="field-label">{{ column.label }}</div>
            <!-- Field Value - Data display with type-specific formatting -->
            <div class="field-value">
              <!-- Text Column Rendering - Standard text display -->
              <ng-container *ngIf="column.type === 'text'">
                {{ formatValue(row.formEntryData, column) }}
              </ng-container>

              <!-- Date Column Rendering - Localized date formatting -->
              <ng-container *ngIf="column.type === 'date'">
                {{ formatValue(row.formEntryData, column) }}
              </ng-container>

              <!-- Status Column Rendering - Color-coded badge display -->
              <ng-container *ngIf="column.type === 'status'">
                <ion-badge [color]="getStatusColor(row.formEntryData[column.key])">
                  {{ row.formEntryData[column.key] }}
                </ion-badge>
              </ng-container>
            </div>
          </div>
        </div>
      </ion-card-content>
    </ion-card>
    <!-- Loading State Card - Shown when data is being loaded -->
        <ion-card *ngIf="loadingState.isLoading" class="state-card">
      <ion-card-content class="ion-text-center">
        <ion-spinner name="circular"></ion-spinner>
        <p>{{ loadingState.message }}</p>
      </ion-card-content>
    </ion-card>

    <!-- Back to Top Card - Shown when there are entries to scroll through -->
     <ion-card *ngIf="data && data.length > 5" class="no-card-style ion-no-padding ion-no-margin">
     <ion-grid >
      <ion-row class="ion-no-padding ion-no-margin">
        <ion-col size="12" class="ion-text-center">
          <ion-button  expand="block"  (click)="scrollToTop()">
            <ion-icon name="chevron-up-outline" ></ion-icon>
            &nbsp;Back to Top
          </ion-button>
        </ion-col>
      </ion-row>
     </ion-grid>
    </ion-card>


  </div>
</div>

